<ng-container *ngIf="!field.sections">
  <mat-list #list1Component [ngStyle]="field.styles?.list" *ngIf="field.listType == 'action'">
    <mat-list-item *ngFor="let option of field.options" class="pointer" [ngStyle]="field.styles?.option"
      (click)="selected(option, list1Component)">
      <ng-container *ngIf="option.icon">
        <mat-icon mat-list-icon *ngIf="option.icon.engine == 'mat'">{{option.icon.icon}}</mat-icon>
        <mat-icon mat-list-icon *ngIf="option.icon.engine == 'fa'" fontSet="fa" [fontIcon]="option.icon.icon">
        </mat-icon>
      </ng-container>
      <h3 matLine> {{option.title}} </h3>
      <p matLine *ngFor="let line of option.lines">
        {{line}}
      </p>

      <button *ngIf="option.action">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>

  <mat-selection-list #listComponent *ngIf="field.listType == 'selection' || field.listType == 'multiSelection'"
    [multiple]="field.listType == 'multiSelection'">
    <mat-list-option *ngFor="let option of field.options" class="pointer" [ngStyle]="field.styles?.option"
      [value]="option.value" (click)="selected(option, listComponent)">
      <h3 matLine>{{option.title}}</h3>
      <p matLine *ngFor="let line of option.lines" [innerHTML]="line">
      </p>
    </mat-list-option>
  </mat-selection-list>

</ng-container>

<ng-container *ngIf="field.sections">

  <mat-selection-list #list1Component [ngStyle]="field.styles?.list" [multiple]="field.listType == 'multiSelection'">
    <ng-container *ngFor="let section of field.sections">
      <h3 matSubheader>{{section.title}}</h3>

      <mat-list-option *ngFor="let option of section.options" class="pointer" [ngStyle]="field.styles?.option"
        (click)="selected(option, list1Component)">
        <ng-container *ngIf="option.icon">
          <mat-icon mat-list-icon *ngIf="option.icon.engine == 'mat'">{{option.icon.icon}}</mat-icon>
          <mat-icon mat-list-icon *ngIf="option.icon.engine == 'fa'" fontSet="fa" [fontIcon]="option.icon.icon">
          </mat-icon>
        </ng-container>
        <h3 matLine> {{option.title}} </h3>
        <p matLine *ngFor="let line of option.lines">
          {{line}}
        </p>

        <mat-icon *ngIf="field.listType == 'action'">chevron_right</mat-icon>

      </mat-list-option>

      <mat-divider></mat-divider>
    </ng-container>

  </mat-selection-list>
</ng-container>
